const appBar = {
  defaultProps: {
    color: "transparent",
  },

  styleOverrides: {
    root: {
      boxShadow: "none",
      backgroundImage: "none",
    },
    colorInherit: {
      backgroundColor: "transparent",
      backgroundImage: "none",
    },
    colorTransparent: {
      backgroundColor: "transparent",
      backgroundImage: "none",
    },
  },
};

export default appBar;
